import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FlujoAprobaciones } from '../model/flujo-aprobaciones';

const API_OBSERVACIONES = '/Services/AprobarSolicitud/';

@Injectable()
export class FlujoAprobacionesService {

    idsolicitud: number;

    constructor(
        private http: HttpClient
    ) { }

    getAllAprobaciones(solicitudId: number): Observable<FlujoAprobaciones[]> {
        return this.http.get<FlujoAprobaciones[]>(environment.API_BASE + API_OBSERVACIONES + solicitudId);
    }

}
